import bannerStrand from '../../assets/images/Banner_Strand.png'
import usaFlag from '../../assets/images/usa-flag.svg'

export const wacDisclosureContent = {
    "sys": {
        "type": "Array"
    },
    "total": 1,
    "skip": 0,
    "limit": 100,
    "items": [
        {
        "fields": {
            "name": "Colo/Conn Wholesale Acquisition Cost WAC",
            "title": "Colo/Conn Wholesale Acquisition Cost ",
            "slug": "wac-disclosure",
            "seo": {
            "metadata": {
                "tags": [],
                "concepts": []
            },
            "sys": {
                "space": {
                "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "n9bebhw263o0"
                }
                },
                "id": "4hLuoVxij054wwwpKkcQiq",
                "type": "Entry",
                "createdAt": "2023-10-02T18:43:34.168Z",
                "updatedAt": "2023-10-02T18:43:34.168Z",
                "environment": {
                "sys": {
                    "id": "sandbox",
                    "type": "Link",
                    "linkType": "Environment"
                }
                },
                "publishedVersion": 3,
                "revision": 1,
                "contentType": {
                "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "seo"
                }
                },
                "locale": "en-US"
            },
            "fields": {
                "name": "Colo./Conn. Wholesale Acquisition Cost > SEO ",
                "title": "Colo./Conn. Wholesale Acquisition Cost ",
                "no_index": false,
                "no_follow": false
            }
            },
            "content": {
            "metadata": {
                "tags": [],
                "concepts": []
            },
            "sys": {
                "space": {
                "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "n9bebhw263o0"
                }
                },
                "id": "3PWfUkDEkaeMXq2JBTbRRy",
                "type": "Entry",
                "createdAt": "2023-08-24T18:26:37.808Z",
                "updatedAt": "2023-10-02T18:44:31.244Z",
                "environment": {
                "sys": {
                    "id": "sandbox",
                    "type": "Link",
                    "linkType": "Environment"
                }
                },
                "publishedVersion": 8,
                "revision": 3,
                "contentType": {
                "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "richTextContentPageTemplate"
                }
                },
                "locale": "en-US"
            },
            "fields": {
                "name": "Colo./Conn. Wholesale Acquisition Cost > Rich Text",
                "modules": [
                {
                    "metadata": {
                    "tags": [],
                    "concepts": []
                    },
                    "sys": {
                    "space": {
                        "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "n9bebhw263o0"
                        }
                    },
                    "id": "59XcyYEtuSn7hn2v3TrFUH",
                    "type": "Entry",
                    "createdAt": "2023-08-24T18:25:44.792Z",
                    "updatedAt": "2023-10-02T18:44:04.152Z",
                    "environment": {
                        "sys": {
                        "id": "sandbox",
                        "type": "Link",
                        "linkType": "Environment"
                        }
                    },
                    "publishedVersion": 10,
                    "revision": 4,
                    "contentType": {
                        "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "bannerComponent"
                        }
                    },
                    "locale": "en-US"
                    },
                    "fields": {
                    "title": "Colo./Conn. Wholesale Acquisition Cost > Rich Text > Banner",
                    "headline": "Information for Prescribing Practitioners and Pharmacists in Colorado and Connecticut ",
                    "backgroundImage": {
                        "metadata": {
                        "tags": [],
                        "concepts": []
                        },
                        "sys": {
                        "space": {
                            "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "n9bebhw263o0"
                            }
                        },
                        "id": "1Px4l8fvDKjBGrRTCqfWrE",
                        "type": "Asset",
                        "createdAt": "2022-12-29T16:44:45.722Z",
                        "updatedAt": "2022-12-29T16:44:45.722Z",
                        "environment": {
                            "sys": {
                            "id": "sandbox",
                            "type": "Link",
                            "linkType": "Environment"
                            }
                        },
                        "publishedVersion": 5,
                        "revision": 1,
                        "locale": "en-US"
                        },
                        "fields": {
                        "title": "Banner BG strand top right",
                        "description": "Banner BG strand top right",
                        "file": {
                            "url": bannerStrand,
                            "details": {
                            "size": 47693,
                            "image": {
                                "width": 1920,
                                "height": 511
                            }
                            },
                            "fileName": "Banner_BG_strand_right.png",
                            "contentType": "image/png"
                        }
                        }
                    },
                    "country": {
                        "metadata": {
                        "tags": [],
                        "concepts": []
                        },
                        "sys": {
                        "space": {
                            "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "n9bebhw263o0"
                            }
                        },
                        "id": "7sht7920U6vs3CLH2CUyaa",
                        "type": "Entry",
                        "createdAt": "2023-05-18T03:23:50.744Z",
                        "updatedAt": "2023-05-24T22:55:23.250Z",
                        "environment": {
                            "sys": {
                            "id": "sandbox",
                            "type": "Link",
                            "linkType": "Environment"
                            }
                        },
                        "publishedVersion": 6,
                        "revision": 2,
                        "contentType": {
                            "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "country"
                            }
                        },
                        "locale": "en-US"
                        },
                        "fields": {
                        "name": "United States",
                        "isocode": "US",
                        "flag": {
                            "metadata": {
                            "tags": [],
                            "concepts": []
                            },
                            "sys": {
                            "space": {
                                "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "n9bebhw263o0"
                                }
                            },
                            "id": "3aYCbZJiL8aoEKRdhjOXyy",
                            "type": "Asset",
                            "createdAt": "2023-05-24T22:54:50.939Z",
                            "updatedAt": "2023-05-24T22:54:50.939Z",
                            "environment": {
                                "sys": {
                                "id": "sandbox",
                                "type": "Link",
                                "linkType": "Environment"
                                }
                            },
                            "publishedVersion": 5,
                            "revision": 1,
                            "locale": "en-US"
                            },
                            "fields": {
                            "title": "usa flag",
                            "description": "USA Flag",
                            "file": {
                                "url": usaFlag,
                                "details": {
                                "size": 2487,
                                "image": {
                                    "width": 36,
                                    "height": 26
                                }
                                },
                                "fileName": "usa_flag.svg",
                                "contentType": "image/svg+xml"
                            }
                            }
                        },
                        "locales": [
                            "en-US"
                        ]
                        }
                    }
                    }
                },
                {
                    "metadata": {
                    "tags": [],
                    "concepts": []
                    },
                    "sys": {
                    "space": {
                        "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "n9bebhw263o0"
                        }
                    },
                    "id": "2H1rWl7LVimvYsRSbvm4pL",
                    "type": "Entry",
                    "createdAt": "2023-08-24T18:26:27.250Z",
                    "updatedAt": "2024-08-23T13:10:58.184Z",
                    "environment": {
                        "sys": {
                        "id": "sandbox",
                        "type": "Link",
                        "linkType": "Environment"
                        }
                    },
                    "publishedVersion": 43,
                    "revision": 11,
                    "contentType": {
                        "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "richTextContentComponent"
                        }
                    },
                    "locale": "en-US"
                    },
                    "fields": {
                    "title": "Colo./Conn. Wholesale Acquisition Cost > Rich Text > Rich Text Content ",
                    "content": {
                        "nodeType": "document",
                        "data": {},
                        "content": [
                        {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                            {
                                "nodeType": "text",
                                "value": "Moderna COVID-19 Vaccine (mRNA) ",
                                "marks": [
                                {
                                    "type": "underline"
                                }
                                ],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": "2024-2025 Formula",
                                "marks": [
                                {
                                    "type": "underline"
                                }
                                ],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": " ",
                                "marks": [
                                {
                                    "type": "underline"
                                }
                                ],
                                "data": {}
                            }
                            ]
                        },
                        {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                            {
                                "nodeType": "text",
                                "value": "The Colorado Wholesale Acquisition Cost Disclosure Law (Colorado House Bill 19-1131), Colo. Rev. Stat. Ann. § 12-280-308 (HB19-1131), requires that prescription drug manufacturers disclose in writing to Colorado prescribers the Wholesale Acquisition Cost (“WAC”) of marketed drugs when engaging in prescription drug marketing. Connecticut Public Act No. 23-171 (Connecticut House Bill 6669) requires that pharmaceutical manufacturers disclose to a prescribing practitioner or pharmacist, in writing, the list price of legend drugs at the time of each contact. ",
                                "marks": [],
                                "data": {}
                            }
                            ]
                        },
                        {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                            {
                                "nodeType": "text",
                                "value": "WAC prices, as defined by Colorado and federal law, represent Moderna’s published list prices for the products sold to wholesalers, before any discount, rebate, or other price reduction, as reported in wholesale price guides (compendia) or other publications of drug or biological pricing data. The WAC prices (also referred to as list prices) listed below may differ from the prices paid by consumers. The price paid by consumers may be higher or lower than the prices listed below and how much a patient will pay will vary based on the patient’s insurance coverage. To determine the cost of a specific prescription, a patient should contact their preferred pharmacy and/or health insurance company. ",
                                "marks": [],
                                "data": {}
                            }
                            ]
                        },
                        {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                            {
                                "nodeType": "text",
                                "value": "NDC",
                                "marks": [
                                {
                                    "type": "bold"
                                }
                                ],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": ": 80777-0110-93, 80777-0110-96, 80777-0110-01 (Inner Pack NDC)\n",
                                "marks": [],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": "Product",
                                "marks": [
                                {
                                    "type": "bold"
                                }
                                ],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": ": Spikevax® (COVID-19 Vaccine, mRNA) 2024-2025 Formula - Age 12yr.+ \n",
                                "marks": [],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": "Dosage Form",
                                "marks": [
                                {
                                    "type": "bold"
                                }
                                ],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": ": Pre-Filled Syringe \n",
                                "marks": [],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": "Strength",
                                "marks": [
                                {
                                    "type": "bold"
                                }
                                ],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": ": 0.5 mL\n",
                                "marks": [],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": "Package Size",
                                "marks": [
                                {
                                    "type": "bold"
                                }
                                ],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": ": Box of ten (10) doses \n",
                                "marks": [],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": "List Price / Wholesale Acquisition Cost (per dose)",
                                "marks": [
                                {
                                    "type": "bold"
                                }
                                ],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": ": $141.80",
                                "marks": [],
                                "data": {}
                            }
                            ]
                        },
                        {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                            {
                                "nodeType": "text",
                                "value": "NDC",
                                "marks": [
                                {
                                    "type": "bold"
                                }
                                ],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": ": 80777-0291-80, 80777-0291-81, 80777-0291-09 (Inner Pack NDC)\n",
                                "marks": [],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": "Product",
                                "marks": [
                                {
                                    "type": "bold"
                                }
                                ],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": ": ",
                                "marks": [],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": "Moderna COVID-19 Vaccine (2024-2025 Formula)",
                                "marks": [],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": " - Age 6 mos.-11yrs. \n",
                                "marks": [],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": "Dosage Form",
                                "marks": [
                                {
                                    "type": "bold"
                                }
                                ],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": ":  Pre-Filled Syringe  \n",
                                "marks": [],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": "Strength",
                                "marks": [
                                {
                                    "type": "bold"
                                }
                                ],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": ": 0.25 mL \n",
                                "marks": [],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": "Package Size",
                                "marks": [
                                {
                                    "type": "bold"
                                }
                                ],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": ": Box of ten (10) doses \n",
                                "marks": [],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": "List Price / Wholesale Acquisition Cost (per dose)",
                                "marks": [
                                {
                                    "type": "bold"
                                }
                                ],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": ": $129.00  ",
                                "marks": [],
                                "data": {}
                            }
                            ]
                        },
                        {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                            {
                                "nodeType": "text",
                                "value": "The Colorado Wholesale Acquisition Cost Disclosure law also requires that manufacturers provide “at least three generic prescription drugs from the same therapeutic class, or if three are not available, as many as are available for prescriptive use.”  Colorado defines “therapeutic class” as “a group of similar drugs that have the same or similar mechanisms of action and are used to treat a specific condition.”  There are no generic prescription drugs applicable to the products listed above. ",
                                "marks": [],
                                "data": {}
                            }
                            ]
                        },
                        {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                            {
                                "nodeType": "text",
                                "value": "Colorado State Board of Pharmacy",
                                "marks": [
                                {
                                    "type": "underline"
                                }
                                ],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": " ",
                                "marks": [],
                                "data": {}
                            }
                            ]
                        },
                        {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                            {
                                "nodeType": "text",
                                "value": "For more information on the Colorado Wholesale Acquisition Cost Disclosure law and the state’s WAC and therapeutic equivalent requirements, please contact the Colorado State Board of Pharmacy’s office: ",
                                "marks": [],
                                "data": {}
                            }
                            ]
                        },
                        {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                            {
                                "nodeType": "text",
                                "value": "Colorado State Board of Pharmacy \n1560 Broadway, Suite 1350 \nDenver, CO 80202 ",
                                "marks": [],
                                "data": {}
                            }
                            ]
                        },
                        {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                            {
                                "nodeType": "text",
                                "value": "Website: ",
                                "marks": [],
                                "data": {}
                            },
                            {
                                "nodeType": "hyperlink",
                                "data": {
                                "uri": "https://www.colorado.gov/pacific/dora/Pharmacy"
                                },
                                "content": [
                                {
                                    "nodeType": "text",
                                    "value": "https://www.colorado.gov/pacific/dora/Pharmacy",
                                    "marks": [
                                    {
                                        "type": "underline"
                                    }
                                    ],
                                    "data": {}
                                }
                                ]
                            },
                            {
                                "nodeType": "text",
                                "value": "     ",
                                "marks": [],
                                "data": {}
                            }
                            ]
                        },
                        {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                            {
                                "nodeType": "text",
                                "value": "Office: 303-894-7800 \nFax: 303-894-7692 ",
                                "marks": [],
                                "data": {}
                            }
                            ]
                        },
                        {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                            {
                                "nodeType": "text",
                                "value": "Connecticut Public Act No. 23-171 also requires that manufacturers disclose information on the variation efficacy of the drug marketed to different racial and ethnic groups, if such information is available. This information is available in the ",
                                "marks": [],
                                "data": {}
                            },
                            {
                                "nodeType": "hyperlink",
                                "data": {
                                "uri": "https://static.modernatx.com/pm/6cef78f8-8dad-4fc9-83d5-d2fbb7cff867/5efa7d9d-05e8-46b5-945a-637c2867bd00/5efa7d9d-05e8-46b5-945a-637c2867bd00_viewable_rendition__v.pdf"
                                },
                                "content": [
                                {
                                    "nodeType": "text",
                                    "value": "Spikevax Full Prescribing Information",
                                    "marks": [
                                    {
                                        "type": "underline"
                                    }
                                    ],
                                    "data": {}
                                }
                                ]
                            },
                            {
                                "nodeType": "text",
                                "value": " and the ",
                                "marks": [],
                                "data": {}
                            },
                            {
                                "nodeType": "hyperlink",
                                "data": {
                                "uri": "https://static.modernatx.com/pm/6cef78f8-8dad-4fc9-83d5-d2fbb7cff867/b6653c87-2627-405c-b151-be87db581e7d/b6653c87-2627-405c-b151-be87db581e7d_viewable_rendition__v.pdf"
                                },
                                "content": [
                                {
                                    "nodeType": "text",
                                    "value": "Fact Sheet for Healthcare Providers Administering Vaccine",
                                    "marks": [
                                    {
                                        "type": "underline"
                                    }
                                    ],
                                    "data": {}
                                }
                                ]
                            },
                            {
                                "nodeType": "text",
                                "value": " (Emergency Use Authorization of ",
                                "marks": [],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": "Moderna COVID-19 Vaccine (2024-2025 Formula)",
                                "marks": [],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": ", for Individuals 6 Months Through 11 Years of Age). ",
                                "marks": [],
                                "data": {}
                            }
                            ]
                        },
                        {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                            {
                                "nodeType": "text",
                                "value": "This disclosure does not contain any medical or treatment advice. The only purpose of this disclosure is to provide information in accordance with the Colorado Wholesale Acquisition Cost Disclosure Law and Connecticut Public Act No. 23-171. This notice is not intended for consumers or patients. Prescribing and other medical decisions should be based on shared decision-making between a patient and their healthcare provider(s) to determine whether and which treatment options and/or prescription drug(s) are appropriate based on independent clinical decision-making and a review of all relevant information and factors, including the FDA’s approved prescribing information. Patients may also discuss their prescription drug(s) with their preferred pharmacist in collaboration with their healthcare provider(s).   ",
                                "marks": [],
                                "data": {}
                            }
                            ]
                        },
                        {
                            "nodeType": "hr",
                            "data": {},
                            "content": []
                        },
                        {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                            {
                                "nodeType": "text",
                                "value": "mRESVIA® (Respiratory Syncytial Virus Vaccine)",
                                "marks": [
                                {
                                    "type": "underline"
                                }
                                ],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": " ",
                                "marks": [],
                                "data": {}
                            }
                            ]
                        },
                        {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                            {
                                "nodeType": "text",
                                "value": "The Colorado Wholesale Acquisition Cost Disclosure Law (Colorado House Bill 19-1131), Colo. Rev. Stat. Ann. § 12-280-308 (HB19-1131), requires that prescription drug manufacturers disclose in writing to Colorado prescribers the Wholesale Acquisition Cost (“WAC”) of marketed drugs when engaging in prescription drug marketing. Connecticut Public Act No. 23-171 (Connecticut House Bill 6669) requires that pharmaceutical manufacturers disclose to a prescribing practitioner or pharmacist, in writing, the list price of legend drugs at the time of each contact. ",
                                "marks": [],
                                "data": {}
                            }
                            ]
                        },
                        {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                            {
                                "nodeType": "text",
                                "value": "WAC prices, as defined by Colorado and federal law, represent Moderna’s published list prices for the products sold to wholesalers, before any discount, rebate, or other price reduction, as reported in wholesale price guides (compendia) or other publications of drug or biological pricing data. The WAC prices (also referred to as list prices) listed below may differ from the prices paid by consumers. The price paid by consumers may be higher or lower than the prices listed below and how much a patient will pay will vary based on the patient’s insurance coverage. To determine the cost of a specific prescription, a patient should contact their preferred pharmacy and/or health insurance company. ",
                                "marks": [],
                                "data": {}
                            }
                            ]
                        },
                        {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                            {
                                "nodeType": "text",
                                "value": "NDC:",
                                "marks": [
                                {
                                    "type": "bold"
                                }
                                ],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": " 80777-345-96 \n",
                                "marks": [],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": "Product:",
                                "marks": [
                                {
                                    "type": "bold"
                                }
                                ],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": " mRESVIA® (Respiratory Syncytial Virus Vaccine) - Age 60yr.+ \n",
                                "marks": [],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": "Dosage Form:",
                                "marks": [
                                {
                                    "type": "bold"
                                }
                                ],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": " Pre-Filled Syringe \n",
                                "marks": [],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": "Strength:",
                                "marks": [
                                {
                                    "type": "bold"
                                }
                                ],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": " 0.5 ml \n",
                                "marks": [],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": "Package Size:",
                                "marks": [
                                {
                                    "type": "bold"
                                }
                                ],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": " Box of ten (10) doses \n",
                                "marks": [],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": "List Price / Wholesale Acquisition Cost (per dose):",
                                "marks": [
                                {
                                    "type": "bold"
                                }
                                ],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": " $290 ",
                                "marks": [],
                                "data": {}
                            }
                            ]
                        },
                        {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                            {
                                "nodeType": "text",
                                "value": "The Colorado Wholesale Acquisition Cost Disclosure law also requires that manufacturers provide “at least three generic prescription drugs from the same therapeutic class, or if three are not available, as many as are available for prescriptive use.”  Colorado defines “therapeutic class” as “a group of similar drugs that have the same or similar mechanisms of action and are used to treat a specific condition.”  There are no generic prescription drugs applicable to the products listed above. ",
                                "marks": [],
                                "data": {}
                            }
                            ]
                        },
                        {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                            {
                                "nodeType": "text",
                                "value": "Colorado State Board of Pharmacy",
                                "marks": [
                                {
                                    "type": "underline"
                                }
                                ],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": " ",
                                "marks": [],
                                "data": {}
                            }
                            ]
                        },
                        {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                            {
                                "nodeType": "text",
                                "value": "For more information on the Colorado Wholesale Acquisition Cost Disclosure law and the state’s WAC and therapeutic equivalent requirements, please contact the Colorado State Board of Pharmacy’s office: ",
                                "marks": [],
                                "data": {}
                            }
                            ]
                        },
                        {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                            {
                                "nodeType": "text",
                                "value": "Colorado State Board of Pharmacy \n1560 Broadway, Suite 1350 \nDenver, CO 80202 ",
                                "marks": [],
                                "data": {}
                            }
                            ]
                        },
                        {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                            {
                                "nodeType": "text",
                                "value": "Website: ",
                                "marks": [],
                                "data": {}
                            },
                            {
                                "nodeType": "hyperlink",
                                "data": {
                                "uri": "https://www.colorado.gov/pacific/dora/Pharmacy"
                                },
                                "content": [
                                {
                                    "nodeType": "text",
                                    "value": "https://www.colorado.gov/pacific/dora/Pharmacy",
                                    "marks": [
                                    {
                                        "type": "underline"
                                    }
                                    ],
                                    "data": {}
                                }
                                ]
                            },
                            {
                                "nodeType": "text",
                                "value": "     ",
                                "marks": [],
                                "data": {}
                            }
                            ]
                        },
                        {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                            {
                                "nodeType": "text",
                                "value": "Office: 303-894-7800 \nFax: 303-894-7692  ",
                                "marks": [],
                                "data": {}
                            }
                            ]
                        },
                        {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                            {
                                "nodeType": "text",
                                "value": "Connecticut Public Act No. 23-171 also requires that manufacturers disclose information on the variation efficacy of the drug marketed to different racial and ethnic groups, if such information is available. This information is available in the ",
                                "marks": [],
                                "data": {}
                            },
                            {
                                "nodeType": "hyperlink",
                                "data": {
                                "uri": "https://static.modernatx.com/pm/6cef78f8-8dad-4fc9-83d5-d2fbb7cff867/36130c97-6fb0-4bea-9f2e-fb5be7a90729/36130c97-6fb0-4bea-9f2e-fb5be7a90729_viewable_rendition__v.pdf"
                                },
                                "content": [
                                {
                                    "nodeType": "text",
                                    "value": "mRESVIA Full Prescribing Information",
                                    "marks": [],
                                    "data": {}
                                }
                                ]
                            },
                            {
                                "nodeType": "text",
                                "value": ". ",
                                "marks": [],
                                "data": {}
                            }
                            ]
                        },
                        {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                            {
                                "nodeType": "text",
                                "value": "This disclosure does not contain any medical or treatment advice. The only purpose of this disclosure is to provide information in accordance with the Colorado Wholesale Acquisition Cost Disclosure Law and Connecticut Public Act No. 23-171. This notice is not intended for consumers or patients. Prescribing and other medical decisions should be based on shared decision-making between a patient and their healthcare provider(s) to determine whether and which treatment options and/or prescription drug(s) are appropriate based on independent clinical decision-making and a review of all relevant information and factors, including the FDA’s approved prescribing information. Patients may also discuss their prescription drug(s) with their preferred pharmacist in collaboration with their healthcare provider(s).   ",
                                "marks": [],
                                "data": {}
                            }
                            ]
                        },
                        {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                            {
                                "nodeType": "text",
                                "value": "Last updated: 08/23/2024  ",
                                "marks": [
                                {
                                    "type": "bold"
                                },
                                {
                                    "type": "italic"
                                }
                                ],
                                "data": {}
                            },
                            {
                                "nodeType": "text",
                                "value": "\nSpikevax® and mRESVIA® are registered trademarks of Moderna.   ",
                                "marks": [],
                                "data": {}
                            }
                            ]
                        },
                        {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                            {
                                "nodeType": "text",
                                "value": "© 2024 Moderna. LEGAL-US-COV-2400029 08/2024 ",
                                "marks": [],
                                "data": {}
                            }
                            ]
                        }
                        ]
                    },
                    "printButtonLabel": "Print",
                    "country": "[Circular Reference]"
                    }
                }
                ]
            }
            }
        },
        "sys": {
            "id": "22jvFsxpPrKci4MhrmZOcd",
            "type": "Entry"
        }
        }
    ],
    "includes": {
        "Entry": [
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]"
        ],
        "Asset": [
        "[Circular Reference]",
        "[Circular Reference]"
        ]
    }
}